import { render, staticRenderFns } from "./AuditUserLogs.vue?vue&type=template&id=398a27ae&scoped=true"
import script from "./AuditUserLogs.vue?vue&type=script&lang=ts"
export * from "./AuditUserLogs.vue?vue&type=script&lang=ts"
import style0 from "./AuditUserLogs.vue?vue&type=style&index=0&id=398a27ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398a27ae",
  null
  
)

export default component.exports